import axios from "axios";
import {getRelatorioURL} from "@/api/config/init"
import {getEntCnpj, getToken} from "../config/token";

const service = axios.create({
    baseURL: getRelatorioURL(),
    timeout: 900000
});

// request interceptor
service.interceptors.request.use(
    config => {
        config.headers['Authorization'] = `Bearer ${getToken()}`;
        config.headers['X-ACCESS-ENTIDADE-CNPJ'] = `${getEntCnpj()}`;
        return config
    },
    error => {
        return Promise.reject(error)
    }
);

service.interceptors.response.use(
    response => {
        const {data} = response;
        return data
    },
    error => {
        if (typeof error.response === "undefined") {
            return Promise.reject(error);
        }
        return Promise.reject(error);
    }
);

export default service
